(function(angular, Math, isFinite) {
    'use strict';

    // according to https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/trunc
    // ie doesn't support Math.trunc(), so this is a polyfill for it; it's listed at the bottom of the linked page
    
    angular.module('aprima-core').config([
        MathTruncPolyfill,
    ]);

    function MathTruncPolyfill() {
        if (!Math.trunc) {
            Math.trunc = function(v) {
                v = +v;
                if (!isFinite(v)) return v;

                return (v - v % 1)   ||   (v < 0 ? -0 : v === 0 ? v : 0);

                // returns:
                //  0        ->  0
                // -0        -> -0
                //  0.2      ->  0
                // -0.2      -> -0
                //  0.7      ->  0
                // -0.7      -> -0
                //  Infinity ->  Infinity
                // -Infinity -> -Infinity
                //  NaN      ->  NaN
                //  null     ->  0
            };
        }
    }
    
})(window.angular, window.Math, window.isFinite);
